import React, { Component } from 'react';


// import Admin from '../Admin/Admin';
import AddOrderForm from './AddOrderForm';

class AddOrderLandingPage extends Component {
    state = {
        startDate: '',
        patient: '',
        partner: '',
    };

    render() {
        const { history } = this.props;
        return (

            <AddOrderForm
                history={history}
            />

        );
    }
}


export default AddOrderLandingPage;



// WEBPACK FOOTER //
// ./src/component/AddOrder/AddOrderLandingPage.js